module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_UPDATE: _vm.itemId
            })
          },
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_DELETE: _vm.itemId
            })
          },
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_RESET_PASSWORD: _vm.itemId
            })
          },
          on: {
            "click": _vm.updatePassword
          }
        }, [_vm._v("Сбросить пароль")]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [(!_vm.isEdit) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "value": _vm.item.lastName,
      "label": "Фамилия",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "value": _vm.item.firstName,
      "label": "Имя",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "value": _vm.item.middleName,
      "label": "Отчество",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.item.clientEmail,
      "name": "clientEmail",
      "label": "Эл. почта рабочая",
      "type": "text",
      "rules": _vm.clientEmailRules,
      "readonly": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "value": _vm.item.clientPhone,
      "rules": _vm.phoneRules,
      "name": "clientPhone",
      "label": "Тел. рабочий",
      "type": "text",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.item.roleNotes,
      "name": "roleNotes",
      "label": "Зоны ответственности в компании",
      "type": "text",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "label": "Подпись в письмах",
      "readonly": "",
      "heightEditor": _vm.calcHeightEditor(),
      "value": _vm.item.signature
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Эл. почта зарегистрированного пользователя",
      "type": "text",
      "disabled": _vm.registerNew,
      "hint": "Введите адрес, используемый для входа в систему",
      "persistent-hint": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Регистрировать нового пользователя",
      "hide-details": ""
    },
    model: {
      value: (_vm.registerNew),
      callback: function($$v) {
        _vm.registerNew = $$v
      },
      expression: "registerNew"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Фамилия",
      "type": "text",
      "disabled": !_vm.registerNew,
      "rules": _vm.lastnameNotNullRule
    },
    model: {
      value: (_vm.item.lastName),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastName", $$v)
      },
      expression: "item.lastName"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "Имя",
      "type": "text",
      "disabled": !_vm.registerNew
    },
    model: {
      value: (_vm.item.firstName),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstName", $$v)
      },
      expression: "item.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "label": "Отчество",
      "type": "text",
      "disabled": !_vm.registerNew
    },
    model: {
      value: (_vm.item.middleName),
      callback: function($$v) {
        _vm.$set(_vm.item, "middleName", $$v)
      },
      expression: "item.middleName"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "clientEmail",
      "label": "Эл. почта рабочая",
      "type": "text",
      "rules": _vm.clientEmailRules
    },
    model: {
      value: (_vm.item.clientEmail),
      callback: function($$v) {
        _vm.$set(_vm.item, "clientEmail", $$v)
      },
      expression: "item.clientEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.phoneRules,
      "name": "clientPhone",
      "label": "Тел. рабочий",
      "type": "text"
    },
    on: {
      "change": function($event) {
        return _vm.onChangePhone(_vm.item, $event)
      }
    },
    model: {
      value: (_vm.item.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.item, "clientPhone", $$v)
      },
      expression: "item.clientPhone"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "roleNotes",
      "label": "Зоны ответственности в компании",
      "type": "text"
    },
    model: {
      value: (_vm.item.roleNotes),
      callback: function($$v) {
        _vm.$set(_vm.item, "roleNotes", $$v)
      },
      expression: "item.roleNotes"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-0": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "label": "Подпись в письмах",
      "heightEditor": _vm.calcHeightEditor(),
      "name": "signature"
    },
    model: {
      value: (_vm.item.signature),
      callback: function($$v) {
        _vm.$set(_vm.item, "signature", $$v)
      },
      expression: "item.signature"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9d7331c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientAgentForm.vue
// module id = 1008
// module chunks = 1